import PromotionPage from 'pages/PromotionPage/PromotionPage';

export default PromotionPage;
